import {
  prepareRequest
} from './request'
import AccountManager from '../managers/account'

import {
  logger
} from '../utils'
import SettingsManager from '../managers/settings'

export const getPaymentMethods = async () => {
  const token = await AccountManager.getToken()

  const request = prepareRequest({
    method: 'POST',
    url: 'payment/methods',
    token
  })

  const res = await request({})

  return res.data
}

export const getPaymentTokens = async () => {
  const token = await AccountManager.getToken()

  const request = prepareRequest({
    method: 'POST',
    url: 'payment/tokens',
    token
  })

  const res = await request({})

  return res.data
}

export const createPayment = async (paymentOptions) => {
  try {
    paymentOptions.amount = Number.parseInt(paymentOptions.amount)
  } catch (e) {
    paymentOptions.amount = 1000
  }

  logger.debug('[PaymentManager]', 'create payment', paymentOptions)

  const request = prepareRequest({
    url: 'payment/deposits:create',
    method: 'POST',
    headers: {
      lang: SettingsManager.getSettings().lang
    }
  })

  return request(paymentOptions)
}

/*
  Old translation history implementations
*/
export const getTransactionHistory = async (options) => {
  const token = await AccountManager.getToken()

  const request = prepareRequest({
    url: 'payment/operations',
    method: 'POST',
    token
  })

  return request(options)
}

export const createWithdrawal = async (options) => {
  try {
    options.amount = Number.parseInt(options.amount)
  } catch (e) {
    options.amount = 1000
  }

  logger.debug('[PaymentManager]', 'create withdraw', options)

  const request = prepareRequest({
    url: 'payment/withdrawals:create',
    method: 'POST'
  })

  return request(options)
}

export const modifyOperation = (options) => {
  const request = prepareRequest({
    url: 'payment/operations:modify',
    method: 'POST'
  })

  return request(options)
}
